import * as Sentry from "@sentry/react";
import { config } from "../config";
import * as Roles from "../models/security/Roles";
import Constants from "../models/utility/Constants";
import TokenProvider from "../providers/TokenProvider";

export type ISentry = typeof Sentry;
export const updateSentryUserInfo = (sentry: ISentry) => {
    const isLoggedIn = TokenProvider.TokenExistsAndIsNotExpired();
    if (!isLoggedIn) {
        sentry.setUser(null);
        return;
    }

    const token = TokenProvider.GetStoredTokenParsed();

    const userId = token?.nameid;
    const email = token?.sub;
    const roles = token?.roles || [];
    const isStaff = roles.indexOf(Roles.Administrator) > -1;

    sentry.setUser({ id: userId, email });
    sentry.setTag("isStaff", isStaff);
};

const initializeSentry = () => {
    const ENVIRONMENT = config.MODE ?? Constants.NodeEnvironmentDev;
    const SENTRY_DSN = config.VITE_SENTRY_DSN;
    const SENTRY_DEBUG = config.VITE_SENTRY_DEBUG === "true";

    if (SENTRY_DSN) {
        Sentry.init({
            dsn: SENTRY_DSN,
            debug: SENTRY_DEBUG,
            environment: ENVIRONMENT,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false
                })
            ],
            // Performance Monitoring
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled: DEV, TEST, and PRODUCTION environments
            tracePropagationTargets: [
                /^https:\/\/clhbid(?:-dev|-test)?.com\/api/
            ],
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            ignoreErrors: ["gtag/js"] // Ignore errors from Google Analytics
        });
        updateSentryUserInfo(Sentry);
    } else {
        console.warn("`VITE_SENTRY_DSN` not found in environment variables");
    }
};

export default initializeSentry;
